export default function copyNodesActions(nodes, links, linkMap) {
    return dispatch => {
        dispatch({
            type:'COPY_NODES',
            nodes:nodes,
            links:links,
            linkMap:linkMap
        });
    }
}

